import React from "react";
import {formatUnixToDDMMYYYY} from "../../../../../../../utils/momentUtils";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../../../../store/Store";

const EndOfShiftEventDetails = () => {
    const venue = useSelector((state: RootStore) => state.venue);
    const calendarEntry = useSelector((state: RootStore) => state.calendarEntry);
    const eventName = calendarEntry.data?.description || "Unknown Event";
    const eventDate = calendarEntry.data?.startDate
        ? formatUnixToDDMMYYYY(calendarEntry.data.startDate)
        : "Unknown Date";
    const venueName = venue.data?.name || "Unknown Venue";

    return (
        <>
            <div className="eos-section">
                <div className="eos-details">
                    <div className="eos-detail">
                        <h2>Event Name</h2>
                        <p>{eventName}</p>
                    </div>

                    <div className="eos-detail">
                        <h2>Event Date</h2>
                        <p>{eventDate}</p>
                    </div>

                    <div className="eos-detail">
                        <h2>Event Location</h2>
                        <p>{venueName}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EndOfShiftEventDetails;
